import { useState } from 'react';
import Image from 'next/image';

import { Container, Case, Author } from './styles';

import VisibilitySensor from 'react-visibility-sensor';
import { ITestemunho } from '../Providers/ClientCases';

interface IProps {
  testemunhos: ITestemunho[];
}

const ClientCases: React.FC<IProps> = ({ testemunhos }) => {
  const [isVisible, setVisible] = useState(false);

  const firstTestemony = testemunhos[0];
  const secondTestemony = testemunhos[1];
  const thirdTestemony = testemunhos[2];

  const onVisibilityChange = (event: boolean) => {
    if (isVisible) return;

    return setVisible(event);
  };

  return (
    <VisibilitySensor
      onChange={onVisibilityChange}
      minTopValue={150}
      scrollDelay={100}
      partialVisibility
    >
      <Container>
        <div>
          <h2>O que dizem nossos clientes</h2>

          {isVisible && (
            <Case>
              <p>&quot;{firstTestemony.testemunho}&quot;</p>
              <Author>
                <Image
                  src={firstTestemony.src}
                  quality={100}
                  alt={`Imagem da ${firstTestemony.nomeEmpresa}`}
                  width={48}
                  height={48}
                  placeholder="blur"
                  blurDataURL="@/public/blur.png"
                />
                <div>
                  <p>{firstTestemony.nome},</p>
                  <span>{firstTestemony.cargo}</span>
                </div>
              </Author>
            </Case>
          )}
        </div>
        <div>
          {isVisible && (
            <Case>
              <p>&quot;{secondTestemony.testemunho}&quot;</p>
              <Author>
                <Image
                  src={secondTestemony.src}
                  quality={100}
                  alt={`Imagem da ${secondTestemony.nomeEmpresa}`}
                  width={48}
                  height={48}
                  placeholder="blur"
                  blurDataURL="@/public/blur.png"
                />
                <div>
                  <p>{secondTestemony.nome},</p>
                  <span>{secondTestemony.cargo}</span>
                </div>
              </Author>
            </Case>
          )}

          {isVisible && (
            <Case>
              <p>&quot;{thirdTestemony.testemunho}&quot;</p>
              <Author>
                <Image
                  src={thirdTestemony.src}
                  quality={100}
                  alt={`Imagem da ${thirdTestemony.nomeEmpresa}`}
                  width={48}
                  height={48}
                  placeholder="blur"
                  blurDataURL="@/public/blur.png"
                />
                <div>
                  <p>{thirdTestemony.nome},</p>
                  <span>{thirdTestemony.cargo}</span>
                </div>
              </Author>
            </Case>
          )}
        </div>
      </Container>
    </VisibilitySensor>
  );
};

export default ClientCases;
